import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'next/image';
import Link from 'next/link';
import imageLoader from '@/utilites/imageLoader';
import { SkuMainImage } from '@/utilites/get-sku-main-image';
import { memo } from 'react';
interface SearchResultHitProps {
  hit: {
    id: number;
    slug: string;
    mainImageUrl: string;
    description: string;
    name: string;
  };
}

const SearchResultHit = ({ hit }: SearchResultHitProps) => {
  return (
    <Link
      href={`/${hit.slug}`}
      className="text-decoration-none py-3 px-3 shadow-none hover:tw-bg-[#f0f0f0] tw-w-full"
      aria-label={`Go to ${hit.name}`}
    >
      <Row className="align-items-center g-0">
        <Col className="col-auto border rounded">
          <SkuMainImage
            alt={hit.name}
            width={50}
            height={50}
            className="object-fit-contain p-1"
            loader={imageLoader}
            src={hit.mainImageUrl}
          />
        </Col>
        <Col>
          <h5 className="font-size-16 ms-3 text-dark fw-semibold">
            {hit.name}
          </h5>
        </Col>
      </Row>
    </Link>
  );
};
export default memo(SearchResultHit);
